import React, { useState, useEffect } from 'react'
import { Paragraph, Paginator, DataTable, DataTableRow, DataBlock } from '@fs/zion-ui'
import zionDebug from '@fs/zion-debug'
import { getReadableOpCode, useSlsStateContext } from '@fs/zion-sls'
import { getPersonFullName } from '../../../../../shared/utils/utils'
import { useR2StateContext } from '../../../../providers/r2Provider/R2Context'
import styles from './HistoryTable.styles'

import User from '../User'
import { getChangeValues } from '../../../history/utils'

const debug = zionDebug('rip:debug:historyTable')

export default function HistoryTable({ activeHistory }) {
  const state = useR2StateContext()
  const zionSlsState = useSlsStateContext()

  const [pageIndex, setPageIndex] = useState(0)
  const [resultsPerPage, setResultsPerPage] = useState(20)
  const [historyVisible, setHistoryVisible] = useState(activeHistory)

  useEffect(() => {
    const startIndex = resultsPerPage * pageIndex
    const endIndex = resultsPerPage * (pageIndex + 1)
    setHistoryVisible(activeHistory?.slice(startIndex, endIndex) || [])
  }, [activeHistory, pageIndex, resultsPerPage])

  const length = activeHistory?.length || 1

  useEffect(() => {
    if (length) {
      setPageIndex(0)
    }
  }, [length])
  debug('history data', activeHistory)
  debug('history elements', state.elements)
  debug(
    'Element finder',
    state.elements?.find((element) => element.id === '274925af-f018-463a-b0e0-c69cad04ce02')
  )

  const columns = [
    { label: 'Time', size: 'md' },
    { label: 'User', size: 'md' },
    { label: 'Person', size: 'md' },
    { label: 'Change', size: 'md' },
    { label: 'Value', size: 'md' },
  ]

  const getTime = (timestamp) => {
    const date = new Date(timestamp)
    return date.toLocaleString()
  }

  const renderChangeValues = (change) => {
    const value = getChangeValues({ action: change, slsTypes: zionSlsState.types })

    return <DataBlock inline data={value} heading="" />
  }

  return (
    <div css={styles.tableWrapper}>
      <DataTable columns={columns}>
        {/* `data` is our table row data from some endpoint */}
        {historyVisible?.map((change) => {
          return (
            <DataTableRow
              onClick={() => {}}
              key={change.actionId + change.sequenceNumber}
              column1={getTime(change?.journalAttribution?.timestamp)}
              column2={<User userId={change?.journalAttribution?.userId} fallBackToFs />}
              column3={getPersonFullName(change?.personId?.[0], state) || '<Unknown>'}
              column4={getReadableOpCode(change, state.history, state.slsTypes)}
              column5={renderChangeValues(change)}
            >
              {JSON.stringify(change)}
            </DataTableRow>
          )
        })}
      </DataTable>
      {!historyVisible?.length && <Paragraph centered>No Results</Paragraph>}
      <div css={styles.paginator}>
        <Paginator
          index={pageIndex}
          setIndex={setPageIndex}
          pageCount={resultsPerPage}
          setPageCount={setResultsPerPage}
          length={length}
        />
      </div>
    </div>
  )
}
